import { Button } from './ui/button';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleSignInButton({ label = 'Continue with Google', referralCode = null, testId = 'google-signin-btn', variant = 'default' }) {
  const handleClick = () => {
    if (referralCode) {
      sessionStorage.setItem('pending_referral_code', referralCode);
    } else {
      sessionStorage.removeItem('pending_referral_code');
    }
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const isPromoted = variant === 'promoted';

  return (
    <div className="relative">
      {isPromoted && (
        <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 z-10">
          <span
            className="inline-block px-3 py-0.5 bg-[#B94A3E] text-white text-[10px] uppercase tracking-widest rounded-full shadow-sm"
            data-testid="google-recommended-badge"
          >
            Recommended · Fastest
          </span>
        </div>
      )}
      <Button
        type="button"
        onClick={handleClick}
        variant="outline"
        className={
          isPromoted
            ? 'w-full h-12 border-2 border-[#B94A3E] bg-white hover:bg-[#FDF6F5] text-[#1A1A1A] font-medium shadow-[2px_2px_0px_rgba(185,74,62,0.15)] transition-all'
            : 'w-full border-[#E5E0D8] bg-white hover:bg-[#F9F7F3] text-[#1A1A1A]'
        }
        data-testid={testId}
      >
        <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18a10.99 10.99 0 0 0 0 9.86l3.66-2.84z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
        </svg>
        {label}
      </Button>
      {isPromoted && (
        <p className="mt-2 text-center text-[11px] text-[#737373]" data-testid="google-nudge-copy">
          Sign up in one tap — no password to remember
        </p>
      )}
    </div>
  );
}
